import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'styled-components';
import { Field } from 'react-final-form';
import { applyStyles } from 'util/helpers';
import Radio from 'components/common/Radio';
import CustomMedia from 'util/custom-media-query';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';

const RadioField = ({ className, name, labels, values, onChange }) => (
  <div className={className}>
    <Field
      type="radio"
      value={values[0]}
      name={name}
      render={({ input }) => (
        <label>
          <Radio
            {...input}
            onChange={v => {
              input.onChange(v);
              onChange && onChange(v);
            }}
          />
          <span>{labels[0]}</span>
        </label>
      )}
    />
    <Field
      type="radio"
      value={values[1]}
      name={name}
      render={({ input }) => (
        <label>
          <Radio
            {...input}
            onChange={v => {
              input.onChange(v);
              onChange && onChange(v);
            }}
          />
          <span>{labels[1]}</span>
        </label>
      )}
    />
  </div>
);

RadioField.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  labels: PropTypes.arrayOf(PropTypes.string),
  values: PropTypes.arrayOf(PropTypes.string)
};

const commonStyle = css`
  display: flex;
  align-items: center;

  label {
    display: flex;
    align-items: center;
    cursor: pointer;

    input[type='radio'] {
      margin-right: 8px;
    }

    input[type='radio']:checked + span {
      color: ${Colors.orange1};
    }

    &:first-of-type {
      margin-right: 40px;
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  label {
    ${FontStyles.text7};
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  label {
    ${FontStyles.text5};
  }
`;

export default applyStyles(RadioField)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/components/RadioField.js